/*
  Ширина, в которой рисуется график, - настоящая, а не условная.

  🔴 Заведено 30.09.2026 по замечанию владельца: «почему шрифт у блока больше,
  чем у заголовка». Замер объяснил причину и показал, что дело шире вопроса.

  До этого дня графики рисовались в условной рамке шириной 720 и растягивались
  по ширине карточки. Вместе с рамкой растягивались и подписи, поэтому ОДИН И
  ТОТ ЖЕ размер шрифта выходил на экране разным:

    карточка в две колонки - 499 px, растяжение 0,69, подпись 11 px → 7,6 px
    карточка во всю ширину - 1063 px, растяжение 1,48, подпись 12 px → 17,7 px
    заголовок карточки                                                17,0 px

  То есть в широкой карточке подпись перерастала заголовок, а в узкой была вдвое
  мельче самого мелкого шрифта кабинета (12 px). На телефоне выходило около
  6 px - нечитаемо вовсе.

  Лечится тем, что рамка совпадает с настоящей шириной: растяжения нет, и
  объявленный размер шрифта равен видимому. Геометрия при этом не меняется -
  столбики и линии по-прежнему считаются от ширины, только теперь от честной.

  Запасное значение нужно там, где измерить нечем: в проверках кабинета (jsdom)
  `ResizeObserver` не объявлен вовсе, и без запасного графики не отрисовались бы
  ни разу - проверки молча перестали бы что-либо проверять.
*/

import { useCallback, useEffect, useRef, useState } from 'react'

export const FALLBACK_WIDTH = 720

export default function useChartWidth() {
  const [width, setWidth] = useState(FALLBACK_WIDTH)
  const host = useRef(null)

  /*
    Ссылка-обработчик, а не `useRef` с эффектом: узел появляется и исчезает при
    переключении вкладок, и эффект на пустом массиве зависимостей не увидел бы
    второго появления - график остался бы с шириной от прошлого показа.
  */
  const measure = useCallback((node) => {
    host.current = node
    if (node) setWidth(Math.round(node.getBoundingClientRect().width) || FALLBACK_WIDTH)
  }, [])

  useEffect(() => {
    const node = host.current
    if (!node || typeof ResizeObserver === 'undefined') return undefined

    const observer = new ResizeObserver(([entry]) => {
      // Ноль приходит, когда узел спрятан (невыбранная вкладка): держать его
      // значило бы схлопнуть график в точку и потерять его при возврате.
      const measured = Math.round(entry.contentRect.width)
      if (measured > 0) setWidth(measured)
    })
    observer.observe(node)
    return () => observer.disconnect()
  }, [width])

  return [measure, width]
}
